const jsonViewStates = ref<Map<string, { isJsonView: boolean; toggleJsonView: () => void }>>(new Map());

export function useJsonViewModal(windowId?: string) {
    return computed(() => {
        if (windowId) {
            return jsonViewStates.value.get(windowId) || null;
        }
        return null;
    });
}

export function registerJsonViewModal(state: { isJsonView: boolean; toggleJsonView: () => void }, windowId: string) {
    const newMap = new Map(jsonViewStates.value);
    newMap.set(windowId, state);
    jsonViewStates.value = newMap;
}

export function unregisterJsonViewModal(windowId: string) {
    const newMap = new Map(jsonViewStates.value);
    newMap.delete(windowId);
    jsonViewStates.value = newMap;
}
